/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'iconOnlineTest': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" class="st0" d="M11.1 11.2l-1-.8-.4.4 1.7 1.8c.3-.8 1.2-2.3 2.3-3.4l-.1-.2c-1.2.7-2.1 1.7-2.5 2.2z"/><path pid="1" class="st1" d="M11.6 7.6c-1.8 0-3.2 1.4-3.2 3.2S9.8 14 11.6 14s3.2-1.4 3.2-3.2-1.4-3.2-3.2-3.2zm-.3 4.9l-1.7-1.8.4-.4 1 .8c.4-.5 1.3-1.5 2.5-2.3l.1.2c-1 1.2-2 2.8-2.3 3.5z"/><path pid="2" class="st1" d="M4.1 12.3c0-.2.1-.3.3-.3l2.6-.4V9.9H2c-.2 0-.3-.1-.3-.3V2.8c0-.2.1-.3.3-.3h11.2c.2 0 .3.1.3.3v4.5c.2.1.3.2.5.3V2.8c0-.4-.4-.8-.8-.8H2c-.4 0-.8.4-.8.8v6.8c0 .4.4.8.8.8h4.4v.8l-2.1.3c-.4.1-.7.4-.7.8v.5h4.6c-.1-.2-.2-.3-.3-.5H4.1z"/><path pid="3" class="st1" d="M11.6 6.8c.6 0 1.1.1 1.6.3V2.8H2v6h6.2c.7-1.2 1.9-2 3.4-2z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/views/icons/iconOnlineTest.js